import actions from './actions'

const state = () => ({
  history: [],
  loading: true,
  error: false,
});

// getters
const getters = {};

// mutations
const mutations = {
  set_history(state, payload) {
    state.history = payload
    state.loading = false
  },
  set_error_state(state, payload) {
    state.error = payload;
  },
  set_loader(state, payload) {
    state.loading = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
